export default "__VITE_ASSET__0b891a8b__"